"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBigCalendar = require("react-big-calendar");

var _DateCell = _interopRequireDefault(require("./DateCell"));

var _TimeEvent = _interopRequireDefault(require("./TimeEvent"));

var _WeekHeader = _interopRequireDefault(require("./WeekHeader"));

var _HeaderPanel = _interopRequireDefault(require("./HeaderPanel"));

var _EventPopover = _interopRequireDefault(require("./EventPopover"));

var _EventContainerWrapper = _interopRequireDefault(require("./EventContainerWrapper"));

var _TimeSlotWrapper = _interopRequireDefault(require("./TimeSlotWrapper"));

var _utils = require("./utils");

var _propTypes2 = require("../DatePicker/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO: when rewriting components,
//       unify locale and formats to one object
//       for Calendar and DatePicker components
function Calendar(_ref) {
  var data = _ref.data,
      locale = _ref.locale,
      datePickerLabels = _ref.datePickerLabels,
      dayFormat = _ref.dayFormat,
      fullDayFormat = _ref.fullDayFormat,
      firstDayFormat = _ref.firstDayFormat,
      weekdaysFormat = _ref.weekdaysFormat,
      fullMonthFormat = _ref.fullMonthFormat,
      weekdaysShortFormat = _ref.weekdaysShortFormat,
      views = _ref.views,
      localizer = _ref.localizer,
      labels = _objectWithoutProperties(_ref, ["data", "locale", "datePickerLabels", "dayFormat", "fullDayFormat", "firstDayFormat", "weekdaysFormat", "fullMonthFormat", "weekdaysShortFormat", "views", "localizer"]);

  var calendar = (0, _react.useRef)({});

  var _useState = (0, _react.useState)(views[0]),
      _useState2 = _slicedToArray(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var events = (0, _utils.formatEvents)(data);

  var _useState3 = (0, _react.useState)(new Date()),
      _useState4 = _slicedToArray(_useState3, 2),
      now = _useState4[0],
      setNow = _useState4[1];

  var _useState5 = (0, _react.useState)('-10%'),
      _useState6 = _slicedToArray(_useState5, 2),
      top = _useState6[0],
      setTop = _useState6[1];

  var _useState7 = (0, _react.useState)(now),
      _useState8 = _slicedToArray(_useState7, 2),
      activeDate = _useState8[0],
      setActiveDate = _useState8[1];

  (0, _react.useEffect)(function () {
    var timer = window.setInterval(function () {
      setNow(new Date());
    }, 30000);
    return function () {
      window.clearInterval(timer);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setTop((0, _utils.getTimeTopPosition)(now));
  }, [now]);

  var onView = function onView(viewChanged) {
    return setView(viewChanged);
  };

  var showMore = function showMore(total) {
    return "".concat(total, " ").concat(labels.more, "...");
  };

  var eventPropGetter = function eventPropGetter(event) {
    return event.color ? {
      className: "event-".concat(event.color)
    } : {};
  };

  var Header = function Header(props) {
    return (0, _HeaderPanel.default)(_objectSpread(_objectSpread({}, props), {}, {
      view: view,
      views: views,
      labels: labels,
      locale: locale,
      onChange: setView,
      setActiveDate: setActiveDate,
      fullDayFormat: fullDayFormat,
      fullMonthFormat: fullMonthFormat,
      weekdaysShortFormat: weekdaysShortFormat,
      datePickerLabels: datePickerLabels
    }));
  };

  var TimeSlot = function TimeSlot(props) {
    return (0, _TimeSlotWrapper.default)(_objectSpread(_objectSpread({}, props), {}, {
      locale: locale,
      now: now,
      top: top
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-wrapper",
    ref: calendar
  }, /*#__PURE__*/_react.default.createElement(_reactBigCalendar.Calendar, {
    className: "calendar calendar-".concat(view),
    step: 30,
    view: view,
    views: views,
    onView: onView,
    events: events,
    formats: {
      dateFormat: (0, _utils.dateFormat)(dayFormat, firstDayFormat),
      weekdayFormat: weekdaysShortFormat,
      dayFormat: weekdaysFormat,
      dayHeaderFormat: weekdaysFormat
    },
    messages: {
      showMore: showMore
    },
    localizer: localizer,
    eventPropGetter: eventPropGetter,
    components: {
      toolbar: Header,
      eventWrapper: function eventWrapper(props) {
        return (0, _EventPopover.default)(_objectSpread(_objectSpread({}, props), {}, {
          view: view
        }));
      },
      dateCellWrapper: _DateCell.default,
      timeSlotWrapper: TimeSlot,
      timeGutterHeader: function timeGutterHeader() {
        return labels.allDay;
      },
      eventContainerWrapper: function eventContainerWrapper(props) {
        return (0, _EventContainerWrapper.default)(_objectSpread(_objectSpread({}, props), {}, {
          locale: locale,
          top: top
        }));
      },
      week: {
        event: function event(props) {
          return (0, _TimeEvent.default)(_objectSpread(_objectSpread({}, props), {}, {
            locale: locale
          }));
        },
        header: function header(props) {
          return (0, _WeekHeader.default)(_objectSpread({
            dayFormat: dayFormat,
            activeDate: activeDate
          }, props));
        }
      },
      day: {
        event: _TimeEvent.default
      }
    }
  }));
}

Calendar.propTypes = {
  /** The Calendar data */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    color: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    startDate: _propTypes.default.string,
    endDate: _propTypes.default.string,
    allDay: _propTypes.default.bool,
    fewDays: _propTypes.default.bool
  })),

  /** Default calendar views */
  views: _propTypes.default.arrayOf(_propTypes.default.oneOf('month', 'week', 'day')),

  /** Locale text for 'more' text */
  more: _propTypes.default.string,

  /** Locale text for 'day' text */
  day: _propTypes.default.string,

  /** Locale text for 'week' text */
  week: _propTypes.default.string,

  /** Locale text for 'month' text */
  month: _propTypes.default.string,

  /** Locale text for 'today' text */
  today: _propTypes.default.string,

  /** Locale language for 'All day' naming */
  allDay: _propTypes.default.string,

  /** Locale language for months naming */
  locale: _propTypes.default.string,
  datePickerLabels: _propTypes2.datePickerLocalePropTypes,

  /** Object for all possible formats */
  dayFormat: _propTypes.default.string,
  localizer: _propTypes.default.shape({
    format: _propTypes.default.func,
    startOfWeek: _propTypes.default.func
  }),
  fullDayFormat: _propTypes.default.string,
  firstDayFormat: _propTypes.default.string,
  fullMonthFormat: _propTypes.default.string,
  weekdaysFormat: _propTypes.default.string,
  weekdaysShortFormat: _propTypes.default.string
};
Calendar.defaultProps = {
  data: null,
  views: ['month', 'week', 'day'],
  locale: 'en',
  more: 'more',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  today: 'Today',
  allDay: 'All day',
  datePickerLabels: undefined,
  dayFormat: 'D',
  localizer: {
    startOfWeek: function startOfWeek() {},
    format: function format() {}
  },
  fullDayFormat: 'MMMM Do',
  firstDayFormat: 'MMMM Do',
  fullMonthFormat: 'MMMM',
  weekdaysFormat: 'ddd D',
  weekdaysShortFormat: 'dddd'
};
var _default = Calendar;
exports.default = _default;